import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_qvgnvkj5hp: FaireBrandEntity = {
  token: "b_qvgnvkj5hp",
  type: "brand",
  name: "AI Distribution",
  avatarUrl:
    "https://cdn.faire.com/fastly/de3dc9c709b584184e5a22dcb23065069e8581e12976415b7976770cbe5b8107.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/274f3a37d39b96d68bcd44a01ad92a855452063072197b14953bc07eef8e86c2.png",
  logoUrl:
    "https://cdn.faire.com/fastly/de3dc9c709b584184e5a22dcb23065069e8581e12976415b7976770cbe5b8107.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/274f3a37d39b96d68bcd44a01ad92a855452063072197b14953bc07eef8e86c2.png",
  location: "Palmetto, FL, USA",
  minimumOrderDollars: 139,
  rating: 5,
  reviewCount: 1,
  isInsider: true,
  description:
    "In the gaming world, every second counts. Whether you’re in a tense final round, an all-night grind, or just chasing that next achievement, you need energy that keeps up with you. That’s why we created Gamer Bytes—the ultimate snack built by gamers, for gamers.\n\nWe were tired of messy, greasy snacks slowing us down and making our gear suffer. So, we set out to craft a better way to refuel—bites that are bold in flavor, clean to eat, and packed with the right energy to keep your reflexes sharp and your focus locked in. From casual couch sessions to high-stakes tournaments, Gamer Bytes are tested and approved in the real arena: hours of non-stop play.\n\nBut Gamer Bytes is more than just food—it’s a movement. It’s about uniting a community that lives for competition, creativity, and connection. We’re here for every player—PC warriors, console champs, mobile tacticians—because no matter how you play, we believe you deserve a snack that works as hard as you do.\n\nSo load up, level up, and never miss your moment. With Gamer Bytes, you’re always fueled for the fight.",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:50.019Z",
    importedBy: "entity-db-cli",
  },
};
